import { z } from "zod";

export const SearchPilotSchema = z
  .object({
    variant: z.enum(["control", "experiment"]),
  })
  .catchall(z.string().optional());

export type SearchPilotResult = z.infer<typeof SearchPilotSchema>;
